import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';

import { TeInputComponent } from './te-input-component';

/** Input Number Component */

@customElement('te-input-number')
export class TeInputNumber extends TeInputComponent {
  static styles = [
    ...TeInputComponent.styles,
    css`
      input[type='number'] {
        -moz-appearance: textfield;
      }
    `,
  ];

  /** Minimum numeric value for input*/
  @property({ type: Number }) minValue = -Infinity;
  /** Maximum numeric value for input*/
  @property({ type: Number }) maxValue = Infinity;

  render() {
    return html`
      <div class="wrapper">
        <div class="te-input" style=${styleMap(this.getWrapperStyle())}>
          ${this.renderLabel()} ${this.renderInput('number', false, this.minValue, this.maxValue)}
          ${this.renderLoader()}
        </div>
        ${this.renderCharCount()} ${this.renderError()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-input-number': TeInputNumber;
  }
}
